<template>
    <div class="result-item-group">
        <ResultItemCardMain :item="item"
                            :is-separators-available="availableDrawerSeparators.length > 0"/>
        <div class="tc-sidebar-items-expansion"
             v-if="availableDrawerSeparators.length > 0 &&
             storeCaseConfiguration.getIsDrawerExpandedByPrototypeId(item.prototypeId)">
            <div class="tc-sidebar-items-expansion-arrow"
                 v-on:click="deleteDropdownSeparatorsAndClose()">
                <SVGShelfSeparatorDropdown/>
            </div>
            <div class="tc-sidebar-items-expansion-items"
                 v-if="availableDrawerSeparators.length > 0">
                <ResultItemCardChild v-for="el in availableDrawerSeparators"
                                     :item="el"
                                     :drawer-prototype-id="item.prototypeId"
                                     :max-count="item.count"/>
            </div>
            <div class="tc-sidebar-items-no-separators"
                 v-else>
                Нет доступных разделителей
            </div>
        </div>
    </div>

</template>

<script>
import SVGShelfSeparatorDropdown from '@/UI/SVG/SVGShelfSeparatorDropdown.vue';
import ResultItemCardMain from '@/UI/RightSidebar/Components/ResultItemCardMain.vue';
import ResultItemCardChild from '@/UI/RightSidebar/Components/ResultItemCardChild.vue';
import { useStoreCaseConfiguration } from '@/Store/storeCaseConfiguration';
import { getDrawerSeparatorsByDrawerId, getPrototypeByID } from '@/libs/libraryGetters';

export default {
    name: 'ResultItemCard',
    components: {
        ResultItemCardChild,
        ResultItemCardMain,
        SVGShelfSeparatorDropdown,
    },
    props: [
        'item',
    ],
    setup() {
        const storeCaseConfiguration = useStoreCaseConfiguration();
        return {
            storeCaseConfiguration,
        };
    },
    methods: {
        getPrototypeByID,
        getDrawerSeparatorsByDrawerId,
        deleteDropdownSeparatorsAndClose() {
            this.storeCaseConfiguration.setDrawerExpandedByPrototypeId(this.item.prototypeId, false);
            //     TODO удаление
        },
    },
    computed: {
        availableDrawerSeparators() {
            return getDrawerSeparatorsByDrawerId(this.item.prototypeId);
        },
    },
};
</script>

<style scoped lang="scss">
@import "CSS/rigtSIdebarItems";

.tc-sidebar-items-no-separators {
    padding: 5px;
    box-sizing: border-box;
    overflow: hidden;
    text-align: left;
}
</style>
